export default __webpack_public_path__ + "static/media/safe-recommendations--tablet@2x.7d86a999.webp";